<div class="rs-flex-grow">
  <div class="rs-maxh rs-padding-bottom2">
    <span id="ac-managePanel-anchor" aria-hidden="true" tabindex="-1"></span>
    <div class="panel rs-maxh rs-no-margin" id="ac-managePanel" role="region" aria-live="polite">
      <div class="jsrs-default-view" *ngIf="selectedViewType === ViewType.DEFAULT">
        <div class="rs-flex-row rs-flex-middle-small-only">
          <px-alert
            [alertKey]="'publicWifiUpdateAlert' + getValueWithoutDomain(account.technicalLoginId)"
          ></px-alert>
          <div class="rs-flex-columns">
            {{ 'publicWifi.accountList.manage.login' | translate }}
          </div>
          <div class="rs-flex-columns rs-flex-grow">
            <div class="rs-flex-row rs-flex-collapse rs-flex-middle">
              <div class="rs-flex-columns small-9">
                <strong class="rs-word-break-all">{{ account.login }}</strong>
              </div>
              <div class="rs-flex-columns small-3">
                <div class="text-right">
                  <button
                    class="rs-link-action rs-link-action-edit jsrs-show-mail"
                    [disabled]="updateAliasPending"
                    data-tms-event="button-click"
                    data-tms-button-zone="public wifi account"
                    attr.data-tms-button-name="{{
                      'publicWifi.accountList.manage.edit' | translate
                    }}"
                    aria-controls="ac-managePanel"
                    (click)="toggleEditLogin()"
                  >
                    <span class="rs-link-action-label show-for-medium-up" aria-hidden="true"
                      >{{ 'publicWifi.accountList.manage.edit' | translate
                      }}<span class="show-for-sr">{{
                        'publicWifi.accountList.manage.edit' | translate
                      }}</span></span
                    ><span
                      class="rs-action-link-icon"
                      title="{{ 'publicWifi.accountList.manage.edit' | translate }}"
                      ><span class="show-for-sr">{{
                        'publicWifi.accountList.manage.edit' | translate
                      }}</span></span
                    >
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="rs-h-s1"></div>
        <div class="rs-flex-row rs-flex-middle-small-only">
          <div class="rs-flex-columns">
            {{ 'publicWifi.accountList.manage.password' | translate }}
          </div>
          <div class="rs-flex-columns rs-flex-grow">
            <div class="rs-flex-row rs-flex-middle">
              <div class="rs-flex-column">********</div>
              <div class="rs-flex-column rs-flex-shrink">
                <button
                  class="rs-link-action rs-link-action-edit jsrs-show-password"
                  [disabled]="updatePasswordPending"
                  data-tms-event="button-click"
                  data-tms-button-zone="public wifi account"
                  attr.data-tms-button-name="{{ 'publicWifi.accountList.manage.edit' | translate }}"
                  aria-controls="ac-managePanel"
                  (click)="toggleEditPassword()"
                >
                  <span class="rs-link-action-label show-for-medium-up" aria-hidden="true"
                    >{{ 'publicWifi.accountList.manage.edit' | translate
                    }}<span class="show-for-sr">{{
                      'publicWifi.accountList.manage.edit' | translate
                    }}</span></span
                  ><span
                    class="rs-action-link-icon"
                    title="{{ 'publicWifi.accountList.manage.edit' | translate }}"
                    ><span class="show-for-sr">{{
                      'publicWifi.accountList.manage.edit' | translate
                    }}</span></span
                  >
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="rs-me"></div>
        <p
          class="rs-txt-s3"
          [innerHTML]="'publicWifi.accountList.manage.description' | translate"
        ></p>
      </div>
      <div class="jsrs-edit-mail-view" *ngIf="selectedViewType === ViewType.EDIT_LOGIN">
        <px-alert
          [alertKey]="'publicWifiUpdateAlert' + getValueWithoutDomain(account.technicalLoginId)"
        ></px-alert>
        <div class="rs-form-item" [ngClass]="!isLoginValid && 'error'">
          <div class="rs-flex-row">
            <div class="rs-flex-column">
              <input
                type="text"
                id="ac-login"
                name="input"
                [(ngModel)]="login"
                (ngModelChange)="validateLogin()"
                aria-describedby="ac-login-helper ac-login-success ac-login-error"
                value="mascotte"
                class="rs-filled"
              />
              <label class="rs-form-label" for="ac-login">{{
                'publicWifi.accountList.manage.editMode.login' | translate
              }}</label>
            </div>
            <div class="rs-flex-column rs-flex-shrink">
              <div class="rs-padding-top2" id="ac-login-helper">
                {{ 'publicWifi.accountList.manage.editMode.domainName' | translate }}
              </div>
            </div>
          </div>
          <div class="rs-form-helper">
            <ul>
              <li *ngIf="isLoginValid" class="rs-form-success" id="ac-login-success">
                {{ 'publicWifi.accountList.manage.editMode.successMessageLogin' | translate }}
              </li>
              <li *ngIf="!isLoginValid" class="rs-form-error" id="ac-login-error">
                {{ 'publicWifi.accountList.manage.editMode.errorMessageLogin' | translate }}
              </li>
            </ul>
          </div>
        </div>
        <div class="rs-flex-row rs-justify-right rs-flex-middle-medium rs-flex-dir-col-small-only">
          <div class="rs-flex-columns rs-order-m2">
            <div class="small-only-text-center">
              <button
                class="rs-btn"
                [disabled]="!isLoginValid || !isLoginModified || updateAliasPending"
                data-tms-event="button-click"
                data-tms-button-zone="public wifi account"
                attr.data-tms-button-name="{{
                  'publicWifi.accountList.manage.editMode.save' | translate
                }}"
                (click)="saveLogin()"
              >
                {{ 'publicWifi.accountList.manage.editMode.save' | translate
                }}<span class="show-for-sr">{{
                  'publicWifi.accountList.manage.editMode.save' | translate
                }}</span>
              </button>
            </div>
          </div>
          <div class="rs-flex-columns" *ngIf="updateAliasPending">
            <px-loading-spinner></px-loading-spinner>
            <span class="show-for-sr">{{
              'publicWifi.accountList.manage.updateAlias.spinner.accessibility' | translate
            }}</span>
          </div>
          <div class="rs-flex-columns rs-order-m1">
            <p class="small-only-text-center">
              <button
                class="rs-btn-no-style rs-link rs-txt-hover jsrs-show-default"
                aria-controls="ac-managePanel"
                [disabled]="updateAliasPending"
                data-tms-event="button-click"
                data-tms-button-zone="public wifi account"
                attr.data-tms-button-name="{{
                  'publicWifi.accountList.manage.editMode.cancel' | translate
                }}"
                (click)="cancel()"
              >
                {{ 'publicWifi.accountList.manage.editMode.cancel' | translate }}
              </button>
            </p>
          </div>
        </div>
      </div>
      <div class="jsrs-edit-password-view" *ngIf="selectedViewType === ViewType.EDIT_PASSWORD">
        <px-alert
          [alertKey]="'publicWifiUpdateAlert' + getValueWithoutDomain(account.technicalLoginId)"
        ></px-alert>
        <div class="row">
          <div class="columns small-12 medium-9 end">
            <div class="rs-form-item">
              <input
                type="password"
                id="ac-pwd"
                name="password2"
                [(ngModel)]="password"
                #password2="ngModel"
                (ngModelChange)="validatePassword()"
                aria-describedby="ac-helper-pwd ac-success-pwd ac-error-pwd"
                class=""
              />
              <span
                class="jsrs-togglePassword rs-see-pwd"
                aria-label="See or hide password"
                role="button"
                tabindex="0"
              ></span>
              <label class="rs-form-label" for="ac-pwd">{{
                'publicWifi.accountList.manage.editMode.newPassword' | translate
              }}</label>
              <div class="rs-form-helper">
                <ul>
                  <li id="ac-helper-pwd">
                    {{ 'publicWifi.accountList.manage.editMode.passwordHelper' | translate }}
                  </li>
                  <li *ngIf="isPasswordValid" class="rs-form-success" id="ac-success-pwd">
                    {{
                      'publicWifi.accountList.manage.editMode.successMessagePassword' | translate
                    }}
                  </li>
                  <li
                    *ngIf="!isPasswordValid && (password2.touched || password2.dirty)"
                    class="rs-form-error"
                    id="ac-error-pwd"
                  >
                    {{ 'publicWifi.accountList.manage.editMode.errorMessagePassword' | translate }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="rs-form-item">
              <input
                type="password"
                id="ac-password3"
                name="password3"
                [(ngModel)]="confirmPassword"
                #password3="ngModel"
                (ngModelChange)="validateConfirmPassword()"
                aria-describedby="ac-error-password3"
              />
              <span
                class="jsrs-togglePassword rs-see-pwd"
                aria-label="See or hide password"
                role="button"
                tabindex="0"
              ></span>
              <label class="rs-form-label" for="ac-password3">{{
                'publicWifi.accountList.manage.editMode.confirmNewPassword' | translate
              }}</label>
              <div class="rs-form-helper">
                <ul>
                  <li
                    *ngIf="!isConfirmPasswordValid && (password3.touched || password3.dirty)"
                    class="rs-form-error"
                    id="ac-error-password3"
                  >
                    {{
                      'publicWifi.accountList.manage.editMode.errorMessagePasswordNotIdentical'
                        | translate
                    }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="rs-flex-row rs-justify-right rs-flex-middle-medium rs-flex-dir-col-small-only">
          <div class="rs-flex-columns rs-order-m2">
            <div class="small-only-text-center">
              <button
                class="rs-btn"
                [disabled]="!isPasswordValid || !isConfirmPasswordValid || updatePasswordPending"
                (click)="savePassword()"
                data-tms-event="button-click"
                data-tms-button-zone="public wifi account"
                attr.data-tms-button-name="{{
                  'publicWifi.accountList.manage.editMode.save' | translate
                }}"
              >
                {{ 'publicWifi.accountList.manage.editMode.save' | translate
                }}<span class="show-for-sr">{{
                  'publicWifi.accountList.manage.editMode.save' | translate
                }}</span>
              </button>
            </div>
          </div>
          <div class="rs-flex-columns" *ngIf="updatePasswordPending">
            <px-loading-spinner></px-loading-spinner>
            <span class="show-for-sr">{{
              'publicWifi.accountList.manage.updatePassword.spinner.accessibility' | translate
            }}</span>
          </div>
          <div class="rs-flex-columns rs-order-m1">
            <p class="small-only-text-center">
              <button
                class="rs-btn-no-style rs-link rs-txt-hover jsrs-show-default"
                aria-controls="ac-managePanel"
                (click)="cancel()"
                [disabled]="updatePasswordPending"
                data-tms-event="button-click"
                data-tms-button-zone="public wifi account"
                attr.data-tms-button-name="{{
                  'publicWifi.accountList.manage.editMode.cancel' | translate
                }}"
              >
                {{ 'publicWifi.accountList.manage.editMode.cancel' | translate }}
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
